import { ITelemetry } from '@iamexperiences/ecos-telemetry';
import moment from 'moment';

interface IConvertDateTimeFormatProps {
  telemetry: ITelemetry;
  dateTime: string;
  timezonePreferenceOffset?: number | null;
  dateFormat?: string;
  timeFormat?: string;
}

export const convertDateTimeFormat = (props: IConvertDateTimeFormatProps): string => {
  const { telemetry, dateTime, timezonePreferenceOffset } = props;
  let { dateFormat, timeFormat } = props;

  let validatedDateTime = new Date(Date.parse(dateTime));
  if (timezonePreferenceOffset != null) {
    // The number of minutes returned by getTimezoneOffset() is positive if the local time zone is behind UTC
    const localTimezoneOffsetInMinute = 0 - validatedDateTime.getTimezoneOffset();
    // Adjust the timezone offset if Time zone is set in Region settings
    const adjustedTimezoneOffsetInMs = timezonePreferenceOffset - localTimezoneOffsetInMinute * 60 * 1000;
    validatedDateTime = new Date(validatedDateTime.getTime() + adjustedTimezoneOffsetInMs);
  }

  // Use this localizedFormatDateTime if unable to get a valid formatted datetime from Region settings
  const localizedFormatDateTime = validatedDateTime.toLocaleString();

  const useDateFormat = dateFormat && dateFormat.length > 0;
  const useTimeFormat = timeFormat && timeFormat.length > 0;

  if (!useDateFormat || !useTimeFormat) {
    addTelemetry(telemetry, 'browser-locale', props, localizedFormatDateTime);
    return localizedFormatDateTime;
  }

  // Tokens used by momnet are case-sensitive
  dateFormat = (dateFormat as string).toUpperCase();
  // moment uses 'a' as input for post or ante meridiem format
  timeFormat = (timeFormat as string).replace('tt', 'a');

  const formattedDate = moment(validatedDateTime).format(dateFormat);
  // invalid.format(anyFmt) results in 'Invalid Date' in the current locale
  if (formattedDate.toLowerCase().includes('invalid date')) {
    addTelemetry(telemetry, 'invalid-date', props, localizedFormatDateTime);
    return localizedFormatDateTime;
  }
  const formattedTime = moment(validatedDateTime).format(timeFormat);
  if (formattedTime.toLowerCase().includes('invalid date')) {
    addTelemetry(telemetry, 'invalid-time', props, localizedFormatDateTime);
    return localizedFormatDateTime;
  }

  const formattedDateTime = `${formattedDate} ${formattedTime}`;
  addTelemetry(telemetry, 'region-setting-locale', props, formattedDateTime);

  return formattedDateTime;
};

const addTelemetry = (
  telemetry: ITelemetry,
  eventName: string,
  props: IConvertDateTimeFormatProps,
  convertedDateTime: string,
) => {
  telemetry.reportCustomEvent('termsofuse/format-datetime/' + eventName, {
    raw: props.dateTime,
    timezone: props.timezonePreferenceOffset,
    dateFormat: props.dateFormat,
    timeFormat: props.timeFormat,
    convertedDateTime: convertedDateTime,
  });
};
